import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from "../constants/initialState";
import API from '../api/Api';
import LocalStorage from '../components/LocalStorage';
import { translationRequest } from './AppReducer';

// User login request
export const userLogin = createAsyncThunk(
    'login/userlogin',
    async ({ email, password }, thunkAPI) => {
        try {
            const result = await API.postData('venues/login', { email, password });
            const response = result.data;
            if (response.status) {
                const data = response.data;
                delete data.password;//Remove key
                delete data.original_pass;//Remove key
                LocalStorage.persistLogin(data.access_token, 720, data);
                return data;
            } else {
                return thunkAPI.rejectWithValue(response);
            }
        } catch (err) {
            return thunkAPI.rejectWithValue({ error: err.message });
        }
    }
);

const loginReducer = createSlice({
    name: 'login',
    initialState: initialState.login,
    reducers: {
        clearState(state) {
            Object.assign(state, initialState.login);
        },
        togglePassword(state, action) {
            state.toggle_password = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(userLogin.pending, (state) => {
            state.isFetching = true;
        });
        builder.addCase(userLogin.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccess = true;
            state.user = payload;
        });
        builder.addCase(userLogin.rejected, (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.error || payload.message;
        });
    }
});

export const translationAndLogin = (params, module) => async (dispatch) => {
    await dispatch(translationRequest({ module_id: module }));
    return await dispatch(userLogin(params));
}

export const { togglePassword, clearState } = loginReducer.actions;
export default loginReducer.reducer;